/**
 * ScrollPositionStore
 *
 * Persists scroll positions for dashboard view routes so that
 * navigating to /matters and back restores the user's scroll position.
 */

import { create } from 'zustand';

interface ScrollPositionState {
  /** Scroll positions keyed by pathname (e.g. '/all' → 320) */
  positions: Record<string, number>;
}

interface ScrollPositionActions {
  save: (pathname: string, scrollTop: number) => void;
  get: (pathname: string) => number;
}

const useScrollPositionStore = create<
  ScrollPositionState & ScrollPositionActions
>()((set, get) => ({
  positions: {},
  save: (pathname, scrollTop) =>
    set((state) => ({
      positions: { ...state.positions, [pathname]: scrollTop }
    })),
  get: (pathname) => get().positions[pathname] ?? 0
}));

export function getScrollPositionActions() {
  return {
    save: useScrollPositionStore.getState().save,
    get: useScrollPositionStore.getState().get
  };
}

export { useScrollPositionStore };
